document.addEventListener("DOMContentLoaded", function(){

    let settings = {
      megaMenu: document.getElementById('mega-menu-section'),
      sectionId: 'header',
      desktopMenu: {
        container: ".mega-menu",
        shopAll: ".mega-menu__shop-all-wrapper--content",
        category: ".mega-menu__category-wrapper--content"
      },
      mobileMenu: ".mobile-menu"
    };
    
  
    if (settings.megaMenu){
      loadAsyncSection(settings);
    }
    
    function loadAsyncSection(settings) { 
      fetch(`/pages/menu-json/?view=styles&sections=${settings.sectionId}`)
      .then((response) => {
        return response.text();
      })
      .then(function (data) {
        let parser = new DOMParser();
        let results = JSON.parse(data);
        let docElement = parser.parseFromString(results[settings.sectionId], 'text/html');
        let desktopMenuContainer = document.querySelector(settings.desktopMenu.container);
        desktopMenuContainer.innerHTML = docElement.querySelector(settings.desktopMenu.container).innerHTML;

        //initialise js for mega menu here
  
      })
      .catch(function (err) {
        console.warn(`Unable to load section ${settings.sectionId}`, err);
      });
    }
  });